export default [
  {
    "index": 1,
    "logo": "html5.svg",
    "title": "HTML5"
  },
  {
    "index": 2,
    "logo": "css3.svg",
    "title": "CSS3"
  },
  {
    "index": 3,
    "logo": "javascript.svg",
    "title": "Javascript"
  },
  {
    "index": 4,
    "logo": "vuedotjs.svg",
    "title": "VueJS"
  },
  {
    "index": 5,
    "logo": "nuxtdotjs.svg",
    "title": "NuxtJS"
  },
  {
    "index": 6,
    "logo": "sass.svg",
    "title": "Sass"
  },
  {
    "index": 7,
    "logo": "nodedotjs.svg",
    "title": "Node.js"
  },
  {
    "index": 8,
    "logo": "express.svg",
    "title": "Express"
  },
  {
    "index": 9,
    "logo": "microsoftsqlserver.svg",
    "title": "MSSQL"
  },
  {
    "index": 10,
    "logo": "github.svg",
    "title": "Github"
  },
  {
    "index": 11,
    "logo": "netlify.svg",
    "title": "Netlify"
  },
  {
    "index": 12,
    "logo": "vercel.svg",
    "title": "Vercel"
  },
  {
    "index": 13,
    "logo": "wordpress.svg",
    "title": "WordPress"
  },
  {
    "index": 14,
    "logo": "tailwindcss.svg",
    "title": "Tailwind CSS"
  },
  {
    "index": 15,
    "logo": "php.svg",
    "title": "PHP"
  },
  {
    "index": 16,
    "logo": "npm.svg",
    "title": "NPM"
  },
  {
    "index": 17,
    "logo": "postman.svg",
    "title": "Postman"
  }
]
